import AddIcon from '@mui/icons-material/Add'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import ButtonBar from '@/components/inputs/ButtonBar'
import CustomButton from '@/components/inputs/CustomButton'
import PageHeader from '@/components/layouts/PageHeader'
import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import BidHistoriesViewContent from '@/features/bidding/components/BidHistoriesViewContent'
import CountrySelector from '@/features/bidding/components/CountrySelector'

const BidHistoriesView = () => {
  const { t } = useTranslation()
  const { permissions } = usePermissions()
  const canMutateBidding = permissions.has('biddingMutation')

  return (
    <>
      <PageHeader
        appBarContent={
          <Box alignItems="center" display="flex" flexDirection="row" sx={{ width: '100%' }}>
            <Box display="flex" flexDirection="row" sx={{ flex: 1, justifyContent: 'left' }}>
              <CountrySelector disabled />
            </Box>
            {canMutateBidding && (
              <ButtonBar alignment="right" sx={{ flex: 1 }}>
                <CustomButton
                  color="inheritText"
                  component={Link}
                  startIcon={<AddIcon />}
                  sx={{ color: 'black' }}
                  to="/bidding/todo-list"
                  variant="contained"
                >
                  {t(`bidding.overview.add_new_bid`)}
                </CustomButton>
              </ButtonBar>
            )}
          </Box>
        }
        breadcrumbItems={[{ text: t('component.page_header.bidding'), to: '/bidding' }]}
        pageTitle={t('component.page_header.bid.results.label')}
      />

      <BidHistoriesViewContent shouldUpdateUrlWhenActiveTabChanges={true} />
    </>
  )
}

export default BidHistoriesView
